import Api from '@/services/Api'

export default {
 getTypes () {
   return Api().get("/types");
},
  updateType (params) {
    return Api().put("/types",params);
  },
  addType (params) {
    return Api().post("/types",params);
  },
  getType (params) {
    return Api().get("/types/"+params);
  },
  deleteType(params) {
    return Api().delete("/types/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/TypeService.js